import privateCapabilities from '@cttq/private-capabilities-v3';
import { watch } from 'vue'

export const watermarkDirective = {
  mounted(el:HTMLElement, binding:any) {
    if (binding.arg === false) {
      return
    }
    let config = {
      txt: "",
      color: '#000000',
      font: '微软雅黑',
      fontSize: 16,
      alpha: 0.05,
      width: 300,
      x: 0,
      y: 50,
      angle: -22,
      css: {
        "z-index": 9999,
        "pointer-events": "none",
      },
      mode: 'element'
    };
    if (binding.value) {
      if (binding.value.personName && binding.value.personCode) {
        config.txt =  `${binding.value.personName} ${binding.value.personCode}`;
        // @ts-ignore
        import('gwm').then((gwm) => {
          gwm.default.creation(config);
        })
      }
    } else {
      const globalStateAll = privateCapabilities.userGlobalState()
      const globalState = globalStateAll.state
      const stopWatch = watch(globalState, (newvalue) => {
        if (newvalue && newvalue.userInfo && newvalue.userInfo.personName) {
            stopWatch()
            config.txt =  `${ newvalue.userInfo.personName} ${ newvalue.userInfo.personCode}`;
            // @ts-ignore
            import('gwm').then((gwm) => {
              gwm.default.creation(config);
            })
        }
      })
    }

  },
}

